import { useRuntimeConfig } from "#app";
import { buildMPCConfig } from "#staxmpc/lib/config";
import { SignAlgo } from "#staxmpc/lib/dkls";
import { ECDSAKeyShare } from "#staxmpc/lib/keyshare/ecdsa";
import { EdDSAKeyShare } from "#staxmpc/lib/keyshare/eddsa";
import { useMPCStore } from "#staxmpc/stores/mpc";
import { computed, toValue } from "vue";
export function useMPCKeyShare(storeKey = "default", algorithm = SignAlgo.ECDSA) {
  const mpcStore = useMPCStore(storeKey);
  const moduleConfig = useRuntimeConfig().public.stavaxMPC;
  const keyshare = computed(() => {
    if (!mpcStore.isReady || !mpcStore.shares.share1) {
      return void 0;
    }
    const mpcConfig = buildMPCConfig(moduleConfig);
    const algo = toValue(algorithm);
    if (algo == SignAlgo.ECDSA && mpcStore.shares.share1.ecdsa) {
      return new ECDSAKeyShare(mpcStore.shares.share1.ecdsa, mpcConfig);
    }
    if (algo == SignAlgo.EdDSA && mpcStore.shares.share1.eddsa) {
      return new EdDSAKeyShare(mpcStore.shares.share1.eddsa, mpcConfig);
    }
    return void 0;
  });
  return {
    keyshare,
    async signMessage(hashedMessage) {
      if (!keyshare.value) {
        throw new Error("No wallet to sign message");
      }
      return keyshare.value.signMessage(hashedMessage);
    },
    generateWallet() {
      if (!mpcStore.isReady) {
        throw new Error("mpc store not ready");
      }
      const mpcConfig = buildMPCConfig(moduleConfig);
      const algo = toValue(algorithm);
      if (algo == SignAlgo.ECDSA) {
        return ECDSAKeyShare.generateWallet(mpcConfig);
      }
      if (algo == SignAlgo.EdDSA) {
        return EdDSAKeyShare.generateWallet(mpcConfig);
      }
      throw new Error("Invalid algo");
    }
  };
}
